import { render, staticRenderFns } from "./PgaNotificationItem.vue?vue&type=template&id=3df5e3db&scoped=true&"
import script from "./PgaNotificationItem.vue?vue&type=script&lang=ts&"
export * from "./PgaNotificationItem.vue?vue&type=script&lang=ts&"
import style0 from "./PgaNotificationItem.vue?vue&type=style&index=0&id=3df5e3db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df5e3db",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem,VListItemContent,VListItemGroup})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3df5e3db')) {
      api.createRecord('3df5e3db', component.options)
    } else {
      api.reload('3df5e3db', component.options)
    }
    module.hot.accept("./PgaNotificationItem.vue?vue&type=template&id=3df5e3db&scoped=true&", function () {
      api.rerender('3df5e3db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Shared/Notification/Components/PgaNotificationItem.vue"
export default component.exports